import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageEditorComponent } from './image-editor.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

export class CustomTranslateHttpLoader extends TranslateHttpLoader {
  constructor(http: HttpClient, prefix: string, suffix: string) {
    super(http, prefix, suffix);
  }

  getTranslation(lang: string): Observable<any> {
    return super.getTranslation(lang).pipe(
      catchError((error: any) => {
        console.error('Translation file loading error:', error);
        const fallbackLang = 'en_US'; // Set a fallback language code (e.g., 'en' for English)
        return import(`../../../../assets/locale/menudishes/${fallbackLang}.json`);
      })
    );
  }
}

export function ImageEditorHttpLoaderFactory(http: HttpClient) {
  return new CustomTranslateHttpLoader(
    http,
    '../../assets/locale/menudishes/',
    '.json'
  );
}
@NgModule({
  declarations: [ImageEditorComponent],
  imports: [
    CommonModule,
    ImageCropperModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: ImageEditorHttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: true,
    }),
  ],
  exports: [
    ImageEditorComponent
  ],
})
export class ImageEditorModule { }
